(function () {
  'use strict';

  var nativeSetter = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype, 'value'
  ).set;

  /* 🔥 GLOBAL FLAG TO PREVENT LOOP */
  var isSyncingAll = false;

  function setInputValue(input, newVal, triggerEvents = true) {
    var strVal = String(newVal);

    nativeSetter.call(input, strVal);
    input.setAttribute('value', strVal);

    if (triggerEvents) {
      input.dispatchEvent(new Event('input',  { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* ─────────────────────────────────────────────
     ✅ SYNC WITHOUT INFINITE LOOP
  ───────────────────────────────────────────── */
  function syncAllQtyInputs(sourceInput, value) {
    if (isSyncingAll) return;

    isSyncingAll = true;

    var form = sourceInput.closest('form');
    if (!form) {
      isSyncingAll = false;
      return;
    }

    var allInputs = form.querySelectorAll('input[name="qty"]');

    allInputs.forEach(function (input) {
      if (input === sourceInput) return;

      /* ❗ DO NOT trigger events here */
      setInputValue(input, value, false);
    });

    isSyncingAll = false;
  }

  function initQuantitySelectors(context) {
    context = context || document;

    context.querySelectorAll('quantity-selector').forEach(function (selector) {

      if (selector.dataset.qtyInit === 'true') return;
      selector.dataset.qtyInit = 'true';

      var input    = selector.querySelector('.qty-input');
      var plusBtn  = selector.querySelector('.qty-btn--plus');
      var minusBtn = selector.querySelector('.qty-btn--minus');

      if (!input) return;

      function getMin() { return parseInt(input.getAttribute('min'), 10) || 1; }
      function getMax() { return parseInt(input.getAttribute('max'), 10) || 300; }
      function getVal() { return parseInt(input.value, 10) || getMin(); }

      var intendedValue = getVal();
      var isUpdating    = false;

      /* ── OBSERVER ── */
      var observer = new MutationObserver(function (mutations) {
        if (isUpdating) return;

        mutations.forEach(function (m) {
          if (m.attributeName === 'value') {
            var current = parseInt(input.getAttribute('value'), 10);
            if (!isNaN(intendedValue) && current !== intendedValue) {
              isUpdating = true;
              nativeSetter.call(input, String(intendedValue));
              input.setAttribute('value', String(intendedValue));
              isUpdating = false;
            }
          }
        });
      });

      observer.observe(input, { attributes: true, attributeFilter: ['value'] });

      /* ── VALUE TRAP ── */
      var currentVal = input.value;
      Object.defineProperty(input, 'value', {
        get: function () {
          return currentVal;
        },
        set: function (v) {
          if (isUpdating) {
            currentVal = String(v);
            nativeSetter.call(input, currentVal);
            return;
          }

          var parsed = parseInt(v, 10);
          if (!isNaN(parsed) && parsed === intendedValue) {
            currentVal = String(v);
            nativeSetter.call(input, currentVal);
          }
        },
        configurable: true
      });

      /* ── APPLY VALUE ── */
      function applyValue(newVal) {
        isUpdating    = true;
        intendedValue = newVal;
        currentVal    = String(newVal);

        nativeSetter.call(input, currentVal);
        input.setAttribute('value', currentVal);

        isUpdating = false;

        /* 🔥 SAFE SYNC */
        syncAllQtyInputs(input, newVal);

        /* Only trigger ONCE (on source) */
        setTimeout(function () {
          input.dispatchEvent(new Event('input',  { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, 0);
      }

      /* ── BUTTON EVENTS ── */
      if (plusBtn) {
        plusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var val = getVal();
          if (val < getMax()) applyValue(val + 1);
        });
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var val = getVal();
          if (val > getMin()) applyValue(val - 1);
        });
      }

      /* ── MANUAL INPUT ── */
      input.addEventListener('input', function () {
        if (isSyncingAll) return; // 🔥 prevent loop

        var val = parseInt(input.value, 10) || getMin();

        intendedValue = val;
        currentVal    = String(val);

        syncAllQtyInputs(input, val);
      });

    });
  }

  /* ── INIT ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initQuantitySelectors();
    });
  } else {
    initQuantitySelectors();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initQuantitySelectors(e.target);
  });

  window.initQuantitySelectors = initQuantitySelectors;

})();


(function () {
  'use strict';

  function handleQtySelector() {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    document.querySelectorAll('form[data-product-form]').forEach(form => {

      const mobileWrapper  = form.querySelector('.lg\\:hidden');
      const desktopWrapper = form.querySelector('.lg\\:block');

      if (!mobileWrapper || !desktopWrapper) return;

      const mobileSelector  = mobileWrapper.querySelector('quantity-selector');
      const desktopSelector = desktopWrapper.querySelector('quantity-selector');

      // Already processed safeguard
      if (!mobileSelector || !desktopSelector) return;

      if (isDesktop) {
        // ✅ Desktop → remove mobile
        if (mobileWrapper.parentNode) {
          mobileWrapper.parentNode.removeChild(mobileWrapper);
        }
      } else {
        // ✅ Mobile → remove desktop
        if (desktopWrapper.parentNode) {
          desktopWrapper.parentNode.removeChild(desktopWrapper);
        }
      }

    });
  }

  /* ── INIT ── */
  function init() {
    handleQtySelector();
  }

  /* Run on load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.Shopify && Shopify.designMode) {
        console.log('Resize detected (editor mode)');
        initYourFunction(); // 👈 replace with your logic
      } else {
        location.reload();
      }
    }, 200);
  });

})();